import { __decorate } from "tslib";
import { module } from 'angular';
import { NgModule } from 'angular-ts-decorators';
import { SharedModule } from 'src/shared';
import { AccessoriesSpotController } from './accessories-spot/accessories-spot.controller';
import { EcomStateDirective } from './ecom-state.directive';
import { PriceDisplayStateDirective } from './price-display-state.directive';
var moduleId = 'gn.audio.support.accessories';
var legacyModuleId = moduleId + ".legacy";
module(legacyModuleId, [])
    .controller('AccessoriesSpotController', AccessoriesSpotController);
var AccessoriesModule = (function () {
    function AccessoriesModule() {
    }
    AccessoriesModule = __decorate([
        NgModule({
            declarations: [EcomStateDirective, PriceDisplayStateDirective],
            id: moduleId,
            imports: [legacyModuleId, SharedModule],
            providers: [],
        })
    ], AccessoriesModule);
    return AccessoriesModule;
}());
export { AccessoriesModule };
